import boiLightTokens from "@boi/design-tokens/dist/web/boi/light/tokens.json";
import boiDarkTokens from "@boi/design-tokens/dist/web/boi/dark/tokens.json";
import boiPrideTokens from "@boi/design-tokens/dist/web/boi/pride/tokens.json";
import newIrelandLightTokens from "@boi/design-tokens/dist/web/newIreland/light/tokens.json";
import newIrelandDarkTokens from "@boi/design-tokens/dist/web/newIreland/dark/tokens.json";

import type { BoiThemeTokens, NewIrelandThemeTokens } from "./types";

export const BOI_THEME_TOKENS: BoiThemeTokens = {
  light: boiLightTokens,
  dark: boiDarkTokens,
  pride: boiPrideTokens,
} as const;

export const NEW_IRELAND_THEME_TOKENS: NewIrelandThemeTokens = {
  light: newIrelandLightTokens,
  dark: newIrelandDarkTokens,
} as const;

export * from "../../design-tokens/constants";
